import React from "react"
import PropTypes from "prop-types"

let defaultCurrencySymbol = "€"

const setDefaultCurrency = ( {currencySymbol} ) => {
	defaultCurrencySymbol = currencySymbol
}

export {setDefaultCurrency}


const formatPrice = ( price ) => {
	let f = parseFloat( Math.round( price * 100 ) / 100 )
		.toFixed( 2 )

	if ( window.app && window.app._currentLanguage === "de" ) {
		f = f.replace( ".", "," )
	}

	return f.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, "$1." )
}

const Price = ( {className = "", children, currency = defaultCurrencySymbol} ) => {
	// if (typeof children !== "number") console.warn("Invalid Price: Price must be a number. Instead got:", typeof children, children)
	let price = children
	if ( price === undefined ) return <span>INVALID PRICE</span>
	if ( price === 0 ) return <span className={className}>&nbsp;</span>
	return <span className={className}>{formatPrice( price )}&nbsp;{currency}</span>
}

Price.propTypes = {
	currency: PropTypes.string
}

export {formatPrice}
export default Price



// WEBPACK FOOTER //
// ./src/components/Price/Price.js